import { render, staticRenderFns } from "./District.vue?vue&type=template&id=0c810bf2&scoped=true&"
import script from "./District.vue?vue&type=script&lang=js&"
export * from "./District.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c810bf2",
  null
  
)

export default component.exports